import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Auth0Account } from 'src/app/accounts/interfaces/accounts.types';

/**
 * RxJS operator that converts JWT token to Auth0Account
 *
 * Example:
 * ```
 * this.auth0.token$
 *   .pipe(extractAccount())
 *   .subscribe((account: Auth0Account) => {
 * ```
 */
export function extractAccount() {
  return (source: Observable<string>): Observable<Auth0Account> =>
    source.pipe(
      map((token: string) => {
        return decodeToken(token);
      })
    );
}

export function decodeToken(token: string): Auth0Account {
  return new JwtHelperService().decodeToken(JSON.parse(token || '{}').idToken);
}
